import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'

Vue.use(VueI18n)

const DEFAULT_LANG = 'en'
const LOCALE_KEY = 'localeLanguage'

const locales = {
  zh: Object.assign(require('./zh'), zhLocale),
  en: Object.assign(require('./en'), enLocale),
  pi: require('./pi'),
}

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
})

export const setup = lang => {
  // if (lang === undefined) {
  //   lang = window.localStorage.getItem(LOCALE_KEY)
  //   if (locales[lang] === undefined) {
  //     lang = DEFAULT_LANG
  //   }
  // }
  // window.localStorage.setItem(LOCALE_KEY, lang)

  if (lang === undefined) {

     //let pappLanguage = getCookie("ZSMART_LOCALE");
     let pappLanguage = DEFAULT_LANG;
     if(pappLanguage != ''){
        window.localStorage.setItem(LOCALE_KEY,pappLanguage)
     }
    
     let appLanguage = window.localStorage.getItem(LOCALE_KEY);
     
    if(appLanguage === null || appLanguage === undefined || appLanguage.length <= 0){
      lang = DEFAULT_LANG;
      window.localStorage.setItem(LOCALE_KEY, lang);
    }else{
      lang = appLanguage;

    }
  }

  Object.keys(locales).forEach(lang => {
    document.body.classList.remove(`lang-${lang}`)
  })
  document.body.classList.add(`lang-${lang}`)
  document.body.setAttribute('lang', lang)

  Vue.config.lang = lang
  i18n.locale = lang
}

//读取cookies信息
function getCookie(c_name) {
  if (document.cookie.length > 0) {
      var c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1) {
          c_start = c_start + c_name.length + 1;
          var c_end = document.cookie.indexOf(";", c_start);
          if (c_end == -1) {
              c_end = document.cookie.length;
          }
          return unescape(document.cookie.substring(c_start, c_end));
      }
  }
  return "";
}

setup()
export default i18n
//
// const messages = {
//   en:require('./lang/zh'),
//   zh:require('./lang/en')
// }



// WEBPACK FOOTER //
// ./src/lang/index.js